import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    metaData: {
        name: '',
        fileType: ''
    },
    userFormData: {},
    isJsonValid: false,
    isUploading: false,
    hasUploadFailure: null,
    uploadErrorMsg: '',
    isUploadSuccess: null,
    uploadJsonData: [],
    isLoading: false,
    vendorNames: [],
    hasErrors: 0,
}

const uploadSlice = createSlice({
    name: 'upload',
    initialState,
    reducers: {
        onUploadInit: (state) => {
            state.isUploading = true
        },
        onInit: (state) => {
            state.isLoading = true
            state.hasErrors = 0
        },
        onRequestSuccess: (state, action) => {
            state.vendorNames = action.payload
            state.hasErrors = 0
            state.isLoading = false
        },
        onRequestFailure: (state,action) => {
            state.hasErrors = action.payload
            state.isLoading = false
        },
        onUploadSuccess: (state) => {
            state.hasUploadFailure = false
            state.isUploading = false
            state.isUploadSuccess = true
        },
        onUploadFailure: (state, action) => {
            state.isUploading = false
            state.hasUploadFailure = true
            state.isUploadSuccess = false
            state.uploadErrorMsg = action.payload
        },
        setFileMetaData: (state, action) => {
            state.metaData.name = action.payload.name
            state.metaData.fileType = action.payload.fileType
        },
        validate: (state, action) => {
            state.isJsonValid = action.payload
        },
        fetchJson: (state, action) => {
            state.uploadJsonData = action.payload
        },
        toggleLoading: (state, action) => {
            state.isUploading = action.payload
        },
        resetUploadState: (state) => {
            state.isUploadSuccess = null
            state.hasUploadFailure = null
            state.uploadErrorMsg = ''
            state.isLoading = false
            state.hasErrors = 0
        },
        resetAllUploadInfo: (state) => {
            state.metaData = {
                name: '',
                fileType: ''
            }
            state.userFormData = {}
            state.isJsonValid = false
            state.isUploading = false
            state.hasUploadFailure = null
            state.uploadErrorMsg = ''
            state.isUploadSuccess = null
            state.uploadJsonData = []
            state.vendorNames = []
            state.hasErrors = 0
        }
    }
})

export const { onUploadInit,onUploadSuccess,onUploadFailure,validate,fetchJson,setFileMetaData, toggleLoading, resetUploadState, resetAllUploadInfo, onInit, onRequestSuccess, onRequestFailure } = uploadSlice.actions
export default uploadSlice.reducer